import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Close from "@engineering/icons/close";
import { useLockBodyScroll } from "react-use";
import { BackgroundOverlay, CloseButton, FlexContainer, GridContainer, IconButton, PanelContainer, StyledContent, StyledDialog, StyledDialogPanel } from "./MobileMenu.styles";
var DEFAULT_HEADER_HEIGHT = 32;
var MobileMenu = function(param) {
    var id = param.id, closeMenuLabel = param.closeMenuLabel, icon = param.icon, iconLabel = param.iconLabel, onClose = param.onClose, open = param.open, toggleOpen = param.toggleOpen, topPosition = param.topPosition, renderContent = param.renderContent;
    useLockBodyScroll(open);
    var handleClose = function() {
        toggleOpen();
        if (typeof onClose === "function") {
            onClose();
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                id: id,
                "aria-label": iconLabel,
                icon: icon,
                selected: open,
                size: "medium",
                onClick: toggleOpen
            }),
            /*#__PURE__*/ _jsxs(StyledDialog, {
                show: open,
                topPosition: topPosition || DEFAULT_HEADER_HEIGHT,
                children: [
                    /*#__PURE__*/ _jsx(BackgroundOverlay, {
                        show: open,
                        onClick: handleClose
                    }),
                    /*#__PURE__*/ _jsx(PanelContainer, {
                        children: /*#__PURE__*/ _jsx(GridContainer, {
                            children: /*#__PURE__*/ _jsx(FlexContainer, {
                                children: /*#__PURE__*/ _jsx(StyledDialogPanel, {
                                    show: open,
                                    children: /*#__PURE__*/ _jsxs(StyledContent, {
                                        "data-testid": "menu-content",
                                        children: [
                                            renderContent(toggleOpen),
                                            /*#__PURE__*/ _jsx(CloseButton, {
                                                id: "".concat(id, "-close-button"),
                                                "aria-label": closeMenuLabel,
                                                icon: Close,
                                                onClick: handleClose
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
export { MobileMenu };
